import { render, staticRenderFns } from "./LeaderInfo.vue?vue&type=template&id=0e8d97f6&scoped=true"
import script from "./LeaderInfo.vue?vue&type=script&lang=js"
export * from "./LeaderInfo.vue?vue&type=script&lang=js"
import style0 from "./LeaderInfo.vue?vue&type=style&index=0&id=0e8d97f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8d97f6",
  null
  
)

export default component.exports